import { useEffect } from "react";

import { isRetryableSectionError } from "../../../../services";
import { SECTION_RETRY_DELAY_MS } from "../constants";

// Same section, same pair: a transient failure is retried on its own and never restarts the generation.
export const useSectionRetry = (error: unknown, refetch: () => unknown) => {
  const isRetryable = isRetryableSectionError(error);
  useEffect(() => {
    if (!isRetryable) {
      return undefined;
    }
    const timer = setTimeout(() => {
      void refetch();
    }, SECTION_RETRY_DELAY_MS);
    return () => clearTimeout(timer);
  }, [isRetryable, error, refetch]);
};
